var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.hideTopBar ? 'clear-top' : '',attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view')],1),_c('div',{staticClass:"safe-left",attrs:{"id":"safeLeft"}}),_c('div',{staticClass:"safe-right",attrs:{"id":"safeRight"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }